<template>
    <el-dialog v-dialogDrag  width="1000px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                客户续费记录
            </div>
        </div>
        <div class="dialog_body">
            <el-table
                    ref="treeTable"
                    :data="dataList"
                    height="400"
                    style="width: 100%;"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    border>
                <el-table-column
                        type="index"
                        :index="(pageInfo.page-1) * pageInfo.pagesize+1"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                    <template slot-scope="scope">
                        <el-button @click="delRow(scope.row)" type="danger" size="small">删除</el-button>
                        <el-button @click="editRow(scope.row)" type="primary" size="small">修改</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="departmentNameBill"
                        label="所属单位"
                        align="left"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="projectName"
                        label="项目名称"
                        align="center"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="billNo"
                        label="订单编号"
                        align="center"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="billDate"
                        label="签订日期"
                        align="center"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="customerName"
                        label="客户"
                        align="center"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="renewDate"
                        width="100"
                        label="续费日期">
                </el-table-column>
                <el-table-column
                        prop="renewTotal"
                        width="150"
                        label="续费金额">
                </el-table-column>
                <el-table-column
                        prop="renewBy"
                        width="150"
                        label="续费人">
                </el-table-column>
                <el-table-column
                        prop="expirationDate"
                        width="130"
                        label="维保到期日期">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        width="140"
                        label="备注">
                </el-table-column>
                <el-table-column
                        prop="createBy"
                        width="100"
                        label="登记人">
                </el-table-column>
                <el-table-column
                        prop="createDate"
                        width="130"
                        label="登记时间">
                </el-table-column>
                <el-table-column
                        prop="modifyBy"
                        width="100"
                        label="修改人">
                </el-table-column>
                <el-table-column
                        prop="modifyDate"
                        width="130"
                        label="修改时间">
                </el-table-column>
            </el-table>

            <div class="pagStyle">
                <pagination :pageInfo="pageInfo" @toPage="toPage"></pagination>
            </div>

            <editDialog v-if="showEditDialog"
                        :formData="formData"
                        :loading="dialogLoading"
                        @closeDialog="closeDialog">
            </editDialog>

        </div>
    </el-dialog>
</template>

<script>
    import pagination from "@/components/tools/table/pagination";
    import editDialog from '@/components/page/sale/saleorderrenew/editDialog'

    export default {
        name: "selSupplier",
        props: ['billId'],
        components:{
            pagination,
            editDialog
        },
        data() {
            return {
                dialogLoading: false,
                showEditDialog: false,
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
                dialogVisible: true,
                dialoading: false,
                dataList: [],
            }
        },
        async mounted() {
            await this.getListData();
        },
        methods: {
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            closeDialog() {
                this.showEditDialog = false;
                this.getListData();
            },
            async editRow(row) {
                this.formData = row;
                this.showEditDialog = true;
            },
            async delRow(rows) {

                let param = {
                    url: "/saleorderrenew/delete",
                    param: {
                        renewId: rows.renewId,
                    }
                }
                await this.$sqlOpt.del.del(param, this, this.getListData);

            },
            async search(){
                this.pageInfo.page = 1;
                await this.getListData();
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/saleorderrenew/getByBillId",
                    param: {
                        billId:this.billId,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page,
                    }
                }
                console.log(param)
                const data = await this.$store.dispatch('pubMethod', param)
                console.log(data)
                if (data.infoCode == '0') {
                    this.dataList = data.data.jsonObject.data;
                    this.sumObject = data.data.sumObject;
                    this.pageInfo.total = data.data.jsonObject.count;
                }
                this.dialoading = false;
            },
            toPage() {
                this.getListData();
            },
        },
    }
</script>

